import {Component} from "@angular/core";
import {Title} from "@angular/platform-browser";

@Component({
  selector: "browser-title",
  template: `
  <usecase-container title="Title" src="browser/title">
    <usecase-content>
      <p>document.title = {{title.getTitle()}}</p>        
    </usecase-content>
  </usecase-container>  
    `,
  providers: [Title]
})
export class TitleComponent {
  constructor(private title: Title) {
  }

  ngOnInit() {
    this.title.setTitle("Browser/Title");
  }
}



/** WEBPACK FOOTER **
 ** ./script/browser/title/component.ts
 **/